import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import config from 'config'

import {Wrapper} from 'system/wrapper';
import {List, Image, Head, Meta} from './components';
import Spinner from 'spinner';
import Pagination from 'pagination';
import {Label, Select, SearchFail,
  UniversalDateTime, UniversalDateWrapper, UniversalSelectWrapper, SearchWrapperPortalLowWrap} from 'components/common';
import {ButtonDefault} from 'components/buttons';
import Input from 'form/input';

import {searchNews, loadNewsTags} from 'redux/actions/portal/news';

import calendar from 'images/general/calendar.svg';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import news1 from 'images/general/news.svg';

const mapStateToProps = state => ({
  news: state.news.get('newsList'),
  tags: state.news.get('newsTags'),
  isFetching: state.news.get('newsAreLoading')
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: () => dispatch(loadNewsTags()),
  searchNews: (name, start_date, end_date, tag, offset) =>
    dispatch(searchNews(name, start_date, end_date, tag, "public", 12, offset))
});


class NewsList extends Component {

  constructor(props) {
    super(props);

    this.state = {
      start_date: moment("01-01-2018", "MM-DD-YYYY"),
      end_date: moment(),
      tag: "",
      search: ''
    }
    this.onChangeStartDate = this.onChangeStartDate.bind(this);
    this.onChangeEndDate = this.onChangeEndDate.bind(this);
    this.searchByName = this.searchByName.bind(this);
    this.onTagChange = this.onTagChange.bind(this);
  }

  searchByName(event) {
		this.setState({search: event.target.value})
	}

  onTagChange(event) {
    this.setState({
      tag: event.target.value,
    })
  }

  onChangeStartDate(date) {
    this.setState({
      start_date: date
    })
  }

  onChangeEndDate(date) {
    this.setState({
      end_date: date
    })
  }

  renderDatePublished = date => {
    return date
      ? new Date(date).toLocaleString('uk-UA', config.options)
      : 'Не опубліковано'
  }

  componentDidMount() {
		const page = this.props.match.params.page || 1;
		const offset = 10 * (page - 1);
    this.props.onLoad();
		this.props.searchNews(this.state.search, this.state.start_date, this.state.end_date, this.state.tag || this.props.tag, offset)

	}

	componentWillReceiveProps(nextProps) {
		if (this.props.match.params.page !== nextProps.match.params.page) {
			const page = nextProps.match.params.page || 1;
			const offset = 10 * (page - 1);
			this.props.searchNews(this.state.search, this.state.start_date, this.state.end_date, this.state.tag || this.props.tag, offset)
		}
	}

  render() {
    if (this.props.news === undefined || this.props.tags === undefined) {
      return <Spinner/>;
    }
    const showTagsSelect = this.props.match.url.indexOf("news") !== -1;
    const showDateSelect = this.props.match.url.indexOf('faq') === -1;

    const { news, isFetching } = this.props;

    if (this.props.news === undefined) {
      return (
        <Wrapper>
          <Spinner/>
        </Wrapper>
      )
    }

    return (
      <div>
        {isFetching ? (
          <Spinner/>
        ):(

          <div>
           
          <SearchWrapperPortalLowWrap onSubmit={(event) => {
  						event.preventDefault()
  						this.props.searchNews(this.state.search, this.state.start_date, this.state.end_date, this.state.tag || this.props.tag)
  					}}>
            {showDateSelect ?
  					<Input block="block" label="Пошук за назвою новини" placeholder="Введіть назву новини" value={this.state.search} onChange={this.searchByName}/>
            : 
            <Input block="block" label="Пошук за питанням" placeholder="Введіть Ваше питання" value={this.state.search} onChange={this.searchByName}/>
            }
            
        {showTagsSelect &&
          <UniversalSelectWrapper>
            <Label>Тег новини:</Label>
            {this.props.tags.get('results').size > 0 ? (
              <Select value={this.state.tag} onChange={this.onTagChange}>
                <option selected value="">Всі теги</option>
                {this.props.tags.get('results').map(item => (
                  <option key={item.get('id')} value={item.get('id')}>{item.get('title')}</option>
                ))}
              </Select>
            ):(
              <Select value={this.state.tag} onChange={this.onTagChange}>
                <option defaultValue value="">Всі теги</option>
                {this.props.tags.get('results').map(item => (
                  <option key={item.get('id')} value={item.get('id')}>{item.get('title')}</option>
                ))}
              </Select>
            )}
          </UniversalSelectWrapper>
        }

        {showDateSelect &&
          <UniversalDateWrapper>
            <UniversalDateTime>
              <Label>Початкова дата</Label>
              <DatePicker
                locale="uk-UA"
                selected={this.state.start_date}
                dateFormat="DD-MM-YYYY"
                onChange={this.onChangeStartDate}
              />
            </UniversalDateTime>
            <UniversalDateTime>
              <Label>Кінцева дата</Label>
              <DatePicker
                locale="uk-UA"
                selected={this.state.end_date}
                dateFormat="DD-MM-YYYY"
                onChange={this.onChangeEndDate}
              />
            </UniversalDateTime>
          </UniversalDateWrapper>
        }

          <ButtonDefault type="submit" value="Пошук" />
        </SearchWrapperPortalLowWrap>

          </div>
        )}

        {this.props.news.get('results').size > 0 ? (
          <div>
            {this.props.isLoading ? (
              <Spinner />
            ):(
              <List>
                {news.get('results').map((item, i) => (
                  <li key={item.get('id')}>
                    <Image>
                      <Link to={`/${this.props.url}/detail/${item.get('id')}`}>
                        <img src={item.get('image') ? item.get('image') : news1} alt="news" />
                      </Link>
                    </Image>
                    <Meta>
                      <img src={calendar} alt="calendar" />
                      <span>{this.renderDatePublished(item.get('date_published'))}</span>
                      {item.get('tag_list').map((tag, i) => (
                        <span key={i}>{tag.get('tag_data').get('title')}</span>
                      ))}
                    </Meta>
                    <Head>
                      <Link to={`/${this.props.url}/detail/${item.get('id')}`}>
                        <h4>{item.get('title')}</h4>
                      </Link>
                      <p>{item.get('brief_description')}</p>
                    </Head>
                  </li>
                ))}
              </List>
            )}
          </div>
           
        ):(
          <div>
          {showDateSelect ?
          <SearchFail>Новини відсутні</SearchFail>
          :
          <SearchFail>Питання та відповіді відсутні</SearchFail>
          }
          </div>
        )}

        <Pagination counts={this.props.news.get('count')} path={`/${this.props.url}/`} matched={this.props.match.params.page} limits={11}/>
      </div>
    )
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewsList));



// WEBPACK FOOTER //
// ./src/system/news/news-list.js